export const bg_image_template_10 =
    "https://images-prod.exlyapp.com/exly_images/a203173b-16b9-49d0-9910-da0438ece091/sales_pages/Jfm_1737965327642_template10_bg.png";
